import type { documents as en } from '@/i18n/locales/en/documents';
import type { Translation } from '@/i18n/types';

export const documents: Translation<typeof en> = {
  page: {
    title: 'Documenti',
    lead: 'Carica e gestisci documenti per {{company}}.',
    noScope: 'Seleziona un’azienda per vedere i suoi documenti.',
    forbidden: 'Non sei autorizzato a vedere i documenti di questa azienda.',
  },
  upload: {
    title: 'Carica documento',
    titleField: 'Titolo',
    category: 'Categoria',
    audience: 'Pubblico di destinazione',
    fileUrl: 'URL del file',
    file: 'File',
    upload_status: {
      uploading: 'Caricamento in corso…',
      tooLarge: 'Il file è troppo grande (max 10MB).',
      invalidType: 'Tipo di file non consentito.',
    },
    fileUrlHint: 'Caricato subito; oppure inserisci un URL esistente qui sotto.',
    requiresReadConfirmation: 'Richiedi conferma di lettura',
    requiresReadConfirmationHint: 'I membri devono confermare di aver letto questo documento.',
    submit: 'Carica',
  },
  categories: {
    algemeen: 'Generale',
    beleid: 'Politica',
    veiligheid: 'Sicurezza',
    hr: 'HR',
    vitaliteit: 'Vitalità',
  },
  audiences: {
    iedereen: 'Tutti',
    management: 'Management',
    per_afdeling: 'Per reparto',
    per_locatie: 'Per sede',
  },
  status: {
    gepubliceerd: 'Pubblicato',
    archief: 'Archiviato',
  },
  library: {
    title: 'Libreria documenti',
    empty: 'Nessun documento ancora.',
    totalViews: 'Visualizzazioni totali: {{count}}',
    columns: {
      title: 'Titolo',
      category: 'Categoria',
      views: 'Visualizzazioni',
      status: 'Stato',
    },
  },
  actions: {
    new: 'Carica documento',
    cancel: 'Annulla',
    publish: 'Pubblica',
    archive: 'Archivia',
  },
};
